import service from '../../config/axios.config';

export const fetchComments = ({ objectiveId }) =>
  service.get(`objectives/${objectiveId}/comments`);

export const createComment = ({ objectiveId, comment }) =>
  service.post(`objectives/${objectiveId}/comments`, comment);

export const updateComment = ({ objectiveId, comment }) =>
  service.put(
    `objectives/${objectiveId}/comments/${comment.id}`,
    comment
  );

export const deleteComment = ({ objectiveId, commentId }) =>
  service.delete(
    `/objectives/${objectiveId}/comments/${commentId}`
  );
